module.exports = __webpack_public_path__ + "static/media/DR2.a6835532.JPG";